const config_ql820_nwb = {
    template: `
    <html>
      <head>
        <style>
           @page {
            size: 82mm 62mm;
            margin: 0;
            overflow: hidden;
          }

          @media print {
  @page {
     size: 82mm 62mm;
     margin: 0;
  }
}

          html {
              overflow: hidden;
          }

          body {
            margin: 0;
            padding: 0;
            width: 82mm;
            height: 62mm;
            font-family: Arial, sans-serif;
            position: relative;
            overflow: hidden;
          }

          p {
              margin: 0;
              padding: 0;
          }

        </style>
      </head>
      <body>
        INSERTBODY
      </body>
    </html>
  `,
    width: 62000,
    height: 82000,
};

export default {
    Brother_QL_820NWB: config_ql820_nwb,
};
